export enum OrganisationType {
  Business = 20,
  AccountingFirm = 30,
}
